module.exports = __webpack_public_path__ + "static/hackathon-5-7189cc4889a852dc9fb1821347715354.jpg";